export const fetchSheetData = async (sheetName) => {
  const baseURL = "https://script.google.com/macros/s/AKfycbzLA31Zlvj70lh8po6h50LQONxaWK9kScbdyluWox6crhg1_0xBlN4ms0PGmSGGZ7_o/exec"; // Replace with your URL
  try {
    const res = await fetch(`${baseURL}?sheet=${sheetName}`);
    const data = await res.json();
    return data;
  } catch (err) {
    console.error(`Error fetching ${sheetName}:`, err);
    return [];
  }
};
